import { merge } from "lodash";
import { Routes } from "./router/config";
let config = {
  gtagId: "",
  siteName: "",
  apiUrl: process.env.REACT_APP_API_URL || "/graphql",
  backendUrl: process.env.REACT_APP_BACKEND_URL || "/api",
  s3Url: process.env.REACT_APP_S3_URL || "/files",
  publicS3Url: process.env.REACT_APP_PUBLIC_S3_URL || "/public-files",
  thumbnailUrl: process.env.REACT_APP_THUMBNAIL_URL || "/image-thumbnails",
  videoThumbnailUrl: process.env.REACT_APP_VIDEOTHUMBNAIL_URL || "/video-thumbnails",
  facebookAppId: "",
  googleClientId: "",
  twitterCallbackUrl:
    process.env.REACT_APP_TWITTER_CALLBACK_URL ||
    (typeof window !== "undefined" &&
      `${window.location.protocol}//${window.location.hostname}${
        window.location.port ? ":" + window.location.port : ""
      }${Routes.loginTwitter}`) ||
    "",
  userJoinRole: "customer",
  userPerformerRole: "performer",
  auth: {
    facebook: false,
    twitter: false,
    google: false,
  },
  fileTypes: {
    image: [
      "jpg",
      "jpeg",
      "jpe",
      "heif",
      "heic",
      "png",
      "webp",
      "jxr",
      "jif",
      "jfif",
      "jfi",
      "jp2",
      "j2k",
      "jpf",
      "jpx",
      "jpm",
    ],
    video: ["webm", "mkv", "mov", "qt", "wmv", "mp4", "m4v", "mpg", "mpeg", "mpv", "avi"],
    audio: ["mp3", "aac", "ogg", "m4a"],
    document: ["pdf", "doc", "docx"],
  },
  maxFileSizeUpload: 2147483648,
  questionnaireFields: [
    {
      type: "textarea" as const,
      label: "Experience",
      name: "experience",
      placeholder: "",
    },
    {
      type: "textarea" as const,
      label: "Education",
      name: "education",
      placeholder: "",
    },
  ],
  featureCustomDomain: false,
  webviewTargetOrigin: process.env.REACT_APP_WEBVIEW_TARGET_ORIGIN || "",
  featureLoginAsUser: false,
  featureScreenSharing: true,
  featureHideScrileLink: false,
};

export const setConfig = (override: Record<string, any>) => {
  config = merge(config, override);
};

export default config;
